import React from 'react';

import { SelectOptionWithSubLabelsProps } from './SelectOptionWithSubLabels.interface';
import { useStyles } from './SelectOptionWithSubLabels.styles';
import { DictionaryEntrySubLabel } from 'app/services/dict.service';

export default function SelectOptionWithSubLabels({
  value,
  valueShort,
  subLabels,
}: SelectOptionWithSubLabelsProps) {
  const classes = useStyles();

  const SubLabel = (subLabel: DictionaryEntrySubLabel) => (
    <span key={subLabel}>{subLabel}</span>
  );

  return (
    <div className={classes.root}>
      <span className={classes.label} aria-label={valueShort || value}>
        {valueShort || value}
      </span>
      <span className={classes.subLabel}>
        {subLabels && subLabels.map(SubLabel)}
      </span>
    </div>
  );
}
